import axios from "axios";
import React from "react";
import { Container } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, Redirect, useParams } from "react-router-dom";
import GetActiveLcdData from "../common/getActiveLcdData";
import { getHeaderForAxios } from "../common/getLocalStorageData";
import { IReduxStateData } from "../interfaces/redux";
import ProfileStatisticsSimilarPlayers from "../components/player/profileStatistics/profileStatisticsSimilarPlayers";
import PlayerImageTitleHoriz from "../components/image/playerImageTitleHoriz";
import { deal_type } from "../constant/deal";

interface IPageData {
    "players_data": any
}
let initialData = {
    "players_data": []
}
const DiffTeamPlayersList = () => {
    const [pageDetail, setPageDetail] = useState<IPageData>(initialData);
    const [redirectToNotFound, setRedirectToNotFound] = useState(false)
    const globalState = useSelector((state: IReduxStateData) => state);
    useEffect(() => {
        let globalStateData = GetActiveLcdData(globalState);
        if (globalStateData && globalStateData.tp_identifier && (globalStateData.is_player === deal_type['players_deal'])) {
            let postData = {
                "players_identifier": globalStateData.tp_identifier.split(",")
            }
            axios.post(process.env.REACT_APP_API_URL + '/match/getPlayersDetailWithoutTeam', postData, { headers: getHeaderForAxios() })
                .then(function (response) {
                    if (response.data.success) {
                        setPageDetail(response.data.success)
                    }
                })
                .catch(function (error) {
                    // handle error
                    console.log(error);
                })
        }
        else {
            setRedirectToNotFound(true)
        }
    }, [])
    return (
        redirectToNotFound ? <Redirect to='/404' />
            :
            <React.Fragment>
                <section className="similar-player theme-light-white m-0 py-4">
                    <Container className="theme-light-white">
                        <div className="row py-2">
                            {pageDetail.players_data && pageDetail.players_data.map((element, index) => (
                                <div className="col-12 col-md-6 col-lg-4 pt-2">
                                    <PlayerImageTitleHoriz {...element} />
                                </div>
                            ))}
                        </div>
                    </Container>
                </section>
            </React.Fragment>
    )
}

export default DiffTeamPlayersList;
